import { z } from "zod";

export const getDateNextActionFormSchema = () => {
	return z.object({
		dateNextAction: z.string().nullish(),
	});
};

export type DateNextActionFormModel = z.infer<
	ReturnType<typeof getDateNextActionFormSchema>
>;
